import { render, staticRenderFns } from "./SelectSubDistrictTable.vue?vue&type=template&id=350b6b70&"
import script from "./SelectSubDistrictTable.vue?vue&type=script&lang=js&"
export * from "./SelectSubDistrictTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports